export default "__VITE_ASSET__CPyMlblL__"